import * as iaas from '../models/issas'

/**
 * 云 api 代理
 * @param {Object} data { serviceType: "vpc", action: "DescribeVpc", regionId: 1, data: {offset:0, limit:10} }
 * @param {Object} [opts] 配置项
 * @return {Promise<Object>}
 */
function capiRequest(data, opts) {
  return iaas.apiRequest(data, opts)
}

export default { request: capiRequest };
